import {CheckoutExperiment} from './useCheckoutEntryDetails';

export const getIsBnplOffered = (experiments: CheckoutExperiment[] = []) => {
  const bnplExperiment = experiments.find(
    experiment => experiment.experimentKey === 'ab_zbnpl',
  );

  const isBnplOffered =
    bnplExperiment?.variantKey === 'azbnpl-1' ||
    bnplExperiment?.variantKey === 'azbnpl-2';

  return isBnplOffered;
};
